import { getField, updateField } from 'vuex-map-fields';

/** Référence hors arbre Vuex : évite les erreurs strict mode quand Keycloak mute son instance (ex. loadUserInfo). */
let keycloakRef = null;

const state = {
  keycloakInitialized: false
};

export const getters = {
  getField,

  isReady: state => state.keycloakInitialized && !!keycloakRef,

  hasContactsRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_CONTACTS_RESOURCE),
  hasOffersRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_OFFERS_RESOURCE),
  hasTransportsRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_TRANSPORTS_RESOURCE),
  hasTreatmentsRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_TREATMENTS_RESOURCE),
  hasInvoicesRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_INVOICES_RESOURCE),
  hasPreInvoicesRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_PREINVOICES_RESOURCE),
  hasExitProcessRole: (state, getters) => role => getters['hasRoleForResource'](role, process.env.VUE_APP_KEYCLOAK_EXITPROCESS_RESOURCE),

  isAnnouncementAdmin: () => {
    if (process.env.VUE_APP_KEYCLOAK_ENABLED !== 'true') return true;
    if (!keycloakRef) return false;

    const role = process.env.VUE_APP_ANNOUNCEMENT_ADMIN_ROLE || 'announcement-admin';
    return keycloakRef.hasRealmRole(role);
  },

  /** Access to the settings pages; defaults to the same role as the announcements administration. */
  isSettingsAdmin: () => {
    if (process.env.VUE_APP_KEYCLOAK_ENABLED !== 'true') return true;
    if (!keycloakRef) return false;

    const role = process.env.VUE_APP_SETTINGS_ADMIN_ROLE
      || process.env.VUE_APP_ANNOUNCEMENT_ADMIN_ROLE
      || 'announcement-admin';
    return keycloakRef.hasRealmRole(role);
  },

  userRoles: () => {
    if (!keycloakRef || !keycloakRef.tokenParsed) return [];

    const roles = new Set();
    const tokenParsed = keycloakRef.tokenParsed;

    if (tokenParsed.realm_access && Array.isArray(tokenParsed.realm_access.roles)) {
      tokenParsed.realm_access.roles.forEach(role => {
        if (role) {
          roles.add(role);
        }
      });
    }

    if (tokenParsed.resource_access) {
      Object.keys(tokenParsed.resource_access).forEach(resourceName => {
        const resource = tokenParsed.resource_access[resourceName];
        if (!resource || !Array.isArray(resource.roles)) return;

        resource.roles.forEach(role => {
          if (role) {
            roles.add(`${resourceName}:${role}`);
          }
        });
      });
    }

    return Array.from(roles).sort();
  },

  hasRoleForResource: state => (role, resourceName) => {
    if (process.env.VUE_APP_KEYCLOAK_ENABLED !== 'true') return true;

    if (!keycloakRef) return false;

    return keycloakRef.hasResourceRole(role, resourceName);
  }
};

const mutations = {
  updateField
};

export const actions = {
  setKeycloakInstance({ commit }, keycloak) {
    keycloakRef = keycloak;
    commit('updateField', { path: 'keycloakInitialized', value: !!keycloak });
  },

  loadUserInfo() {
    if (!keycloakRef) {
      return Promise.reject(new Error('Keycloak not initialized'));
    }
    return keycloakRef.loadUserInfo();
  },

  logout() {
    if (keycloakRef) {
      keycloakRef.logout({ redirectUri: window.location.origin });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
